import { Grid, List, Typography } from '@mui/material'

import { ConnectionListItem } from './connections-list-item.component'
import { PlusIcon } from 'src/assets/icons'
import { ETranslationNs, IImpactByIdRawRespDto } from 'src/types'
import { HelperWrapper } from 'src/components'

import useStyles from 'src/components/associations/styles'

interface IProps {
  items: IImpactByIdRawRespDto[]
  handleSelectItem: (value: string) => void
  disable?: boolean
}

export const ConnectionsList = ({ items, handleSelectItem, disable }: IProps) => {
  const classes = useStyles({})

  return (
    <List className={classes.selectionList} disablePadding>
      {items.map((item) => (
        <ConnectionListItem
          icon={item.image_small || item.image}
          text={item.name}
          subText={'#' + item.code}
          key={item.id}
          handleSelectItem={handleSelectItem}
          id={item.id}
          disable={disable}
        />
      ))}
      {items.length === 0 && !disable && (
        <label className={classes.selectionLabel} htmlFor="impact-association">
          <Grid className={classes.selectionWrapper}>
            <Grid className={classes.selectionItem}>
              <Grid className={classes.imageIconWrapper}>
                <PlusIcon className={classes.imageIcon} />
              </Grid>
              <Typography className={`${classes.selectionText} ${classes.selectionTextLight}`}>
                <HelperWrapper t="association-step-impact-link-button" ns={ETranslationNs.Form} />
              </Typography>
            </Grid>
          </Grid>
        </label>
      )}
    </List>
  )
}
